import React from 'react';

import {Footing, Container} from './style';
import Logo from './../../assets/images/amigoo_pet_inverted.svg';

const Footer = () => {
    return(
        <Footing>
            <Container>
                <img src={Logo} alt="Amigoo Pet"/>
                <p>Amigoo Pet Assist | Todos os direitos reservados &copy; 2019</p>
            </Container>
        </Footing>
    )
};

export default Footer;